module.exports = __webpack_public_path__ + "img/3zinesvlog-0001.4c0d4d03.jpeg";